import React from 'react';
import classNames from 'classnames';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        navContainer: {
            width: '96%',
            display: 'flex',
            gap: '32px',
            padding: '16px 0',
            justifyContent: 'flex-start',
            overflowX: 'auto',
            flexShrink: 0
        },
        navItem: {
            position: 'relative',
            color: '#1F2152',
            cursor: 'pointer',
            fontSize: '28px',
            fontWeight: 700,
            lineHeight: '34px',
            opacity: '0.5',
            transition: 'all 0.2s ease-in-out',
            zIndex: 1,
            whiteSpace: 'nowrap',
            flexShrink: 0
        },
        active: {
            cursor: 'default',
            fontSize: '32px',
            opacity: '1',
            lineHeight: '39px'
        },
        underline: {
            position: 'absolute',
            bottom: '-2px',
            left: 0,
            background: '#EAEBFB',
            borderRadius: '5px',
            height: '5px',
            width: '100%',
            zIndex: -1
        }
    })
);

type AdminNavSelectorProps = {
    active: string;
    navItems: string[];
    setActive: (item: string) => void;
};

const AdminNavSelector: React.FC<AdminNavSelectorProps> = ({
    active,
    navItems,
    setActive
}) => {
    const classes = useStyles();

    const navItemClasses = (item: string) => {
        return classNames(classes.navItem, {
            [classes.active]: active === item
        });
    };

    const handleKeyDown = (
        event: React.KeyboardEvent<HTMLDivElement>,
        item: string
    ) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setActive(item);
        }
    };

    return (
        <div
            className={classes.navContainer}
            role="tablist"
            aria-label="Navigation tabs"
        >
            {navItems.map((item, index) => (
                <div
                    key={index}
                    className={navItemClasses(item)}
                    role="tab"
                    tabIndex={0}
                    aria-selected={active === item}
                    aria-label={item}
                    onClick={() => setActive(item)}
                    onKeyDown={(e) => handleKeyDown(e, item)}
                >
                    {item}
                    {active === item && (
                        <span className={classes.underline} />
                    )}
                </div>
            ))}
        </div>
    );
};

export default AdminNavSelector; 